// this Modal is for Technical Support material call to XML file per asset
import React, { useRef } from 'react';
import './Modal.css';


const Modal = ({ show, onClose, children }) => {
    const contentRef = useRef(null);


    if (!show) return null;

    return (
        <div className="modal">
            <div className="modal-content" ref={contentRef}>
                <div className="title-bar">
                    <div className="title-bar-buttons">
                        <button className="close-button" onClick={onClose}>CLOSE PANEL</button>
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};

export default Modal;
